import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { RoutesRoutingModule } from './routes-routing.module';

import { HomeComponent } from './components/home/home.component';
import { ProfileSettingsComponent } from './components/profile/settings.component';
import { Error401Component } from './shared/components/error-code/401.component';
import { Error403Component } from './shared/components/error-code/403.component';
import { Error404Component } from './shared/components/error-code/404.component';
import { Error500Component } from './shared/components/error-code/500.component';
import { DialogRemoveUserComponent, DialogAddUserComponent , DialogEditUserComponent} from './components/admin/users/user.administration.component';
import { LabComponent } from './components/lab/lab.component';

import { LabModule } from './components/lab/lab.module';
import { ReportsComponent } from './components/reports/reports.component';
import { AdminComponent } from './components/admin/admin.component';
import { AdminModule } from './components/admin/admin.module';
import { ReportsModule } from './components/reports/reports.module';
import { WelcomeComponent } from './components/welcome/welcome.component';

const COMPONENTS = [HomeComponent, LabComponent, ReportsComponent,
                    AdminComponent,
                    ProfileSettingsComponent,
                    WelcomeComponent,
                    Error401Component, Error403Component, Error404Component, Error500Component];
const COMPONENTS_DYNAMIC = [DialogRemoveUserComponent, DialogAddUserComponent, DialogEditUserComponent];

@NgModule({
    imports: [SharedModule, RoutesRoutingModule, LabModule, AdminModule, ReportsModule],
    declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC]
})

export class RoutesModule {}
